<template>
  <div id="pagePedido" @click="handleClickOutside">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card>
            <v-toolbar color="primary" dark flat>
              <v-icon class="mr-2">mdi-dolly</v-icon>
              <v-toolbar-title v-if="!$vuetify.breakpoint.mdAndDown">Lista de Pedidos</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-col cols="3" class="mr-3" v-if="!$vuetify.breakpoint.mdAndDown">
                <v-text-field
                  v-model="filter.search"
                  label="Buscar pedido..."
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                  rounded
                  single-line
                  filled
                  dense
                  dark
                ></v-text-field>
              </v-col>
              <v-tooltip top v-if="$vuetify.breakpoint.mdAndDown && !showSearch">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click.stop="toggleSearch">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Buscar</span>
              </v-tooltip>
              <v-col cols="12" v-if="showSearch && $vuetify.breakpoint.mdAndDown">
                <v-text-field
                  ref="searchInput"
                  v-model="filter.search"
                  label="Buscar pedido..."
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                  rounded
                  single-line
                  filled
                  dense
                  dark
                  class="search-input-mobile"
                  @click.stop
                  @input="applyFilter"
                ></v-text-field>
              </v-col>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="showUbicacionForm(null)" class="mr-2">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Agregar Pedido</span>
              </v-tooltip>
              <pedido-form
                v-if="visibleForm"
                v-model="editItem"
                @save="updateDataTable"
                @cancel="visibleForm = false"
              ></pedido-form>
              <recepcionar-form v-if="visibleRecepcionarForm" v-model="editItem" @save="updateDataTable"
                @cancel="visibleRecepcionarForm = false"></recepcionar-form>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="refreshDataTable" v-on="on" class="mr-0">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar lista</span>
              </v-tooltip>
            </v-toolbar>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="filteredPedidos"
                :options.sync="pagination"
                :loading="loadingItems"
                :footer-props="footer"
                :key="tableId"
                class="elevation-1"
                multi-sort
              >
              <template v-slot:item.estado="{ item }">
                  <v-chip :color="getColor(item.estado)" small dark>{{ item.estado }}</v-chip>
                </template>
                <template v-slot:item.action="{ item }">
                  <div :class="[!$vuetify.breakpoint.mdAndDown ? 'd-inline-flex action-column' : '']">
                    <!-- Botón Editar -->
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn depressed icon color="grey" @click="showUbicacionForm(item)" v-on="on">
                          <v-icon color="grey darken-2" size="20">mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                           depressed
                           icon
                           color="grey"
                           :to="{ name: 'PedidoDetail',params: { id: item.id} }"
                           v-on="on"
                        >
                          <v-icon color="grey darken-2" size="20">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver detalles</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn depressed icon color="grey" @click="showRecepcionarForm(item)" v-on="on">
                          <v-icon color="grey darken-2" size="20">mdi-car-cog</v-icon>
                        </v-btn>
                      </template>
                      <span>Recepcionar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>

import RecepcionarForm from './RecepcionarForm'

const STATUS_DISABLED = 0
const STATUS_ENABLED = 1

export default {
  components: {
    RecepcionarForm,
    PedidoForm: () => import(/* webpackPrefetch: true */ './PedidoForm')
  },

  data: () => ({
    // datatable
    loadingItems: false,
    totalItems: 0,
    tableId: 0,
    headers: [
      { text: 'No pedido', value: 'pedido' },
      { text: 'Proveedor', value: 'proveedor', sortable: false },
      { text: 'Fecha', value: 'fecha', sortable: false },
      { text: 'Marca', value: 'marca', sortable: false },
      { text: 'Modelo', value: 'modelo', sortable: false },
      { text: 'Estado', value: 'estado', sortable: false },
      { text: '', value: 'action', sortable: false, align: 'right' }
    ],
    footer: {
      itemsPerPageOptions: [10, 20, 30, 40, 50]
    },

    // filtro
    filter: {
      search: null,
      status: null
    },
    currentFilter: {
      ubicacion: null,
      status: null
    },
    estados: [
      { name: 'Habilitado', value: STATUS_ENABLED },
      { name: 'Deshabilitado', value: STATUS_DISABLED }
    ],

    // form
    visibleForm: false,
    visibleRecepcionarForm: false,
    editItem: null,
    showSearch: false,
    // Ubicaciones de prueba
    pedidos: [
      {
        id: '1',
        pedido: '1',
        proveedor: 'Proveedor 1',
        fecha: '2021-01-01',
        marca: 'Marca 1',
        modelo: 'Modelo 1',
        estado: 'En proceso'
      },
      {
        id: '2',
        pedido: '2',
        proveedor: 'Proveedor 2',
        fecha: '2021-01-02',
        marca: 'Marca 2',
        modelo: 'Modelo 2',
        estado: 'Recibido'
      },
      {
        id: '3',
        pedido: '3',
        proveedor: 'Proveedor 3',
        fecha: '2021-01-03',
        marca: 'Marca 3',
        modelo: 'Modelo 3',
        estado: 'Recibido'
      }
    ],
    // Definir la propiedad pagination en el data
    pagination: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false
    }
  }),
  computed: {
    filteredPedidos () {
      if (!this.filter.search) {
        return this.pedidos
      }
      const search = this.filter.search.toLowerCase()
      return this.pedidos.filter(item => item.marca.toLowerCase().includes(search))
    }
  },

  methods: {
    updateDataTable ({ insert }) {
      this.visibleForm = false
      this.visibleRecepcionarForm = false
      if (insert) {
        this.totalItems++
      }
      this.refreshDataTable()
    },
    refreshDataTable () {
      this.tableId++
    },

    // filtro
    commitFilter () {
      for (let [key] of Object.entries(this.currentFilter)) {
        this.currentFilter[key] = this.filter[key]
      }
    },
    rollbackFilter () {
      for (let [key, value] of Object.entries(this.currentFilter)) {
        this.filter[key] = value
      }
    },
    getColor (estado) {
      return (estado === 'Recibido' ? `green` : `red`)
    },
    handleClickOutside (event) {
      const searchInput = this.$refs.searchInput
      if (searchInput && !searchInput.$el.contains(event.target)) {
        this.showSearch = false
      }
    },
    applyFilter () {
      this.commitFilter()
    },

    // acciones
    showUbicacionForm (item) {
      this.editItem = item
      this.visibleForm = true
    },
    showRecepcionarForm (item) {
      this.editItem = item
      this.visibleRecepcionarForm = true
      this.visibleVehiculoForm = false
    },
    toggleSearch () {
      this.showSearch = !this.showSearch
      if (this.showSearch) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus()
        })
      }
    }
  }
}
</script>
<style scoped>
.search-input-mobile {
  max-width: 200px;
}
</style>
